<template>
  <div class="btn-orange">
    <a :href="url">
      <mdicon name="ListBoxOutline" class="flex justify-center text-white" size="90" />
      <h2 class=" text-white text-2xl text-center font-semibold mb-4">{{ title }}</h2>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      url: 'https://duquedecaxias.rj.gov.br/portal/boletim-oficial.html'
    }
  },
  props: {
    title: String
  },
}
</script>